/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-07-16 13:52:32
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PropTypes from 'prop-types'
import s from '../form.css';
import { parseArrayToTable, parseStringToArray } from '../utils';
import classnames from 'classnames';
import { cloneDeep } from 'lodash';
import { getVisual } from '../../../controller';

const defaultColorValue = '____表格颜色____\t\n表头色块\trgb(91,155,213)\n数据的第一行\trgb(210,222,239)\n数据的第二行\trgb(234,239,247)\n____饼图颜色____\t\n智家定制\trgb(91,155,213)\n日日顺\trgb(237,125,49)\n卡奥斯\trgb(165,165,165)\n海创汇：\trgb(255,192,0)\n产城创：\trgb(68,114,196)\n万链共享\trgb(112,173,71)\n集团平台\trgb(37,94,145)\n家居\trgb(158,72,14)\n其他\trgb(99,99,99)\n'

class Form extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    children: PropTypes.node,
  }
  constructor(props) {
    super(props);

    this.state = {
      value: '',
      colorValue: defaultColorValue,
      dataset: [],
      tableColumns: [],
      tableList: [],
      chartTitle: [],
      chartList: [],
      tableColorList: [],
      chartColorList: [],
    }
  }

  componentDidMount () {
    this.loadData()
  }

  loadData = () => {
    const { onChange } = this.props;

    getVisual(1).then(value => {
      const _table = Form.parse(value);
      const _tempColor = Form.parseColor(defaultColorValue);

      this.setState({
        value: value,
        ..._table,
        ..._tempColor
      })
  
      typeof onChange === 'function' && onChange({
        ..._table,
        ..._tempColor
      });
    });
  }

  static parse = (str) => {
    const dataset = parseStringToArray(str);
    if (!dataset) return null;
    // 解析table
    const { columns: tableColumns, list: tableList} = parseArrayToTable(dataset, {
      handleColumn: (name, index) => ({
        title: name.replace('平台', '<br />平台'),
        style: {
          width: index === 0 ? 120 : 'auto',
          height: 76,
          fontSize: 18,
          lineHeight: '140%',
          color: '#000',
          textAlign: 'center',
          borderRight: '2px solid #fff',
          borderBottom: '6px solid #fff',
          background: '#5b9bd5',
        },
        colStyle: {
          textAlign: 'center',
          fontSize: 18,
          fontWeight: 500,
          lineHeight: '46px',
          height: 47,
          color: '#000',
          borderBottom: '2px solid #fff',
          borderRight: '2px solid #fff',
        }
      })
    })
    const { chartTitle, chartList } = Form.parseChart(cloneDeep(dataset));

    return {
      dataset,
      tableColumns,
      tableList,
      chartTitle,
      chartList,
    }
  }

  static parseChart = (arr) => {
    const result = [];
    arr.forEach((item, index) => {
      if (index === 0) {
        item.forEach(ele => {
          result.push({ title: ele, list: [] });
        })
      } else {
        item.forEach((ele, innerIndex) => {
          result[innerIndex].list.push({
            name: item[0],
            value: ele
          });
        })
      }
    })
    const [title, ...list] = result;

    return {
      chartTitle: title.list,
      chartList: list,
    }
  }

  static parseColor = (str) => {
    const list = str.split(/____[\u4e00-\u9fa5]+____\t\n/).filter(Boolean);
    const [tableColorList, chartColorList] = list.reduce((acc, curr) => {
      const name = curr.split('\n').filter(Boolean).map(item => item.replace(/.+?\t/, ''))
      return [...acc, name]
    }, []);

    return {tableColorList, chartColorList}
  }

  onChange = (e) => {
    const { onChange } = this.props;
    const value = e.target.value;
    const tableData = Form.parse(value);
    this.setState({ value, ...tableData });

    typeof onChange === 'function' && onChange(tableData)
  }

  onChangeColor = (e) => {
    const { onChange } = this.props;
    const colorValue = e.target.value;
    const _color = Form.parseColor(colorValue);

    this.setState({
      colorValue,
      ..._color,
    })

    typeof onChange === 'function' && onChange(_color)
  }

  render() {
    return (
      <div className={s.root}>
        <div>数据设置</div>
        <textarea className={classnames(s.inputText)} value={this.state.value} onChange={this.onChange} />
        <div>颜色设置（颜色只和顺序有关）</div>
        <textarea className={classnames(s.inputText)} value={this.state.colorValue} onChange={this.onChangeColor} />
      </div>
    );
  }
}

export default withStyles(s)(Form);



// WEBPACK FOOTER //
// src/routes/visualChart/P1/Form.js